'use client';
import { Order } from '@/types';
import { Badge, Typography } from '@eventbrite/marmalade';
import moment from 'moment-timezone';
import React from 'react';
import styles from './OrderCard.module.scss';
interface OrderCardProps {
  order: Order;
}

export const OrderCard: React.FC<OrderCardProps> = ({ order }) => {
  const eventTimezone = order.event.start.timezone;
  const eventLocalTime = order.event.start.local;

  const eventFormattedTime = moment.tz(eventLocalTime, eventTimezone).format('ddd, MMM D h:mma z');

  const ordercreationDate = order.creationDate;
  const orderFormattedDate = moment(ordercreationDate).format('ddd, MMM D, YYYY, h:mma');

  return (
    <div className={styles.outerOrderDiv}>
      <Badge variant={'info'} bordered={true}>
        <Typography>
          {order.noOfTickets} ticket{order.noOfTickets !== 1 ? 's' : ''}
        </Typography>
      </Badge>
      <Typography variant="heading-md" className={styles.event_title}>
        {order.event.name.text}
      </Typography>
      <Typography variant="body-lg" className={styles.event_datetime}>
        {eventFormattedTime}
      </Typography>
      <Typography>
        Order #{order.orderId} placed on {orderFormattedDate}{' '}
      </Typography>
    </div>
  );
};
